import conf from '@/utilities/api/conf';

export const DOCUMENT_ACTION = 'DOCUMENT_ACTION';
export const DOCUMENT_REVIEW = 'DOCUMENT_REVIEW';
export const DOCUMENT_PREPUBLISH = 'DOCUMENT_PREPUBLISH';
export const DOCUMENT_PUBLISH = 'DOCUMENT_PUBLISH';
export const DOCUMENT_SUBMIT = 'DOCUMENT_SUBMIT';
export const CAN_HANDLE_CREATIVITY = 'CAN_HANDLE_CREATIVITY';
export const stripHtml = html => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

//conf variables
export const NODE_ENV = conf.value('NODE_ENV');
export const VUE_APP_API_URL = conf.value('VUE_APP_API_URL');
export const VUE_APP_FILE_URL = conf.value('VUE_APP_FILE_URL');
export const VUE_APP_STRIPE_URL = conf.value('VUE_APP_STRIPE_URL');
export const VUE_APP_GOOGLE_API_KEY = conf.value('VUE_APP_GOOGLE_API_KEY');
export const VUE_APP_VERSION_NUMBER = conf.value('VUE_APP_VERSION_NUMBER');
export const VUE_APP_BRAND = conf.value('VUE_APP_BRAND');
export const VUE_APP_BRAND_COLOR = conf.value('VUE_APP_BRAND_COLOR');
export const VUE_APP_INFO_COLOR = conf.value('VUE_APP_INFO_COLOR');
export const VUE_APP_PRIMARYBTN_COLOR = conf.value('VUE_APP_PRIMARYBTN_COLOR');
export const VUE_APP_GOOGLE_ANALYTICS_4 = conf.value(
  'VUE_APP_GOOGLE_ANALYTICS_4'
);
export const VUE_APP_BRAND_TITLE = conf.value('VUE_APP_BRAND_TITLE');

export const QR_APPLY_PROJECT_ID_ROUTES = [
  'viewSelectedProject',
  'viewSelectedProjectGroup'
];
